import { render } from "./MessageBubble.vue?vue&type=template&id=ab5a4748&scoped=true"
import script from "./MessageBubble.vue?vue&type=script&lang=js"
export * from "./MessageBubble.vue?vue&type=script&lang=js"

import "./MessageBubble.vue?vue&type=style&index=0&id=ab5a4748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5a4748"]])

export default __exports__